module.exports = __webpack_public_path__ + "c2b8b20608e3b4f642c748c1ed0ac1ef.jpg";